// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedCustomer: Object,
};

const DeleteAssosiate = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedCustomer,
  } = props;
  const gid = selectedCustomer && selectedCustomer.gid;

  const DeleteSelectedItem = () => {
    submit({
      associateGid: gid,
    });
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteSelectedItem} type="danger">Delete</SpButton>,
      ]}
      title="Delete Shop Associate"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this shop associate?</div>
        <SpH5>
          <div>{selectedCustomer && selectedCustomer.firstName ? selectedCustomer.firstName : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteAssosiate;
